'use client';

import CourseItemBig from "@/components/CourseItemBig/CourseItemBig";
import '@/styles/pages/Courses.css';


const Flag_of_Poland = '/svg/Flag_of_Poland.svg';
const Flag_of_England = '/svg/Flag_of_England.svg';

const coursePolishA1 = {
    primaryColor: '#e25858',
    borderColor: 'rgba(226, 88, 88, 0.5)',
    icon: Flag_of_Poland,
    title: 'Польська мова A1 — твій впевнений старт за 1,5 місяці!',
    courseDuration: '1,5 місяці',
    price: '599 zł',
    numberOfLessons: '22',
    description: (
        <div className="course-description">
            Почни говорити польською вже за 1,5 місяці! Наш курс A1 — це ідеальний вибір для тих, хто ніколи не вивчав польську або хоче освіжити основи.<br/><br/>
            Курс підходить<br/> 👶 тим, хто вивчає польську з нуля,<br/> 🎓 майбутнім студентам польських вишів, <br/>👷‍♀️ тим, хто планує працювати або жити в Польщі, <br/>🌍 тим, хто хоче подорожувати або розширити свої мовні горизонти. <br/><br/>Заняття проходять <br/>📘 за програмою підручника Hurra! Po Polsku 1, <br/>👥 у невеликих групах — більше часу на практику, <br/>🗣️ з максимумом говоріння з першого уроку, <br/>🕒 із зручним розкладом під твій темп життя. <br/><br/>Після курсу ти зможеш: • підтримати розмову на побутові теми <br/> • самостійно вирішувати базові ситуації в Польщі <br/> • почуватися впевнено у спілкуванні з носіями мови <br/> • продовжити навчання на рівні A2. Не відкладай на потім — польська відкриє перед тобою нові можливості. Долучайся до нашої дружньої групи!
        </div>
    )
};

const coursePolishA2 = {

    primaryColor: '#e25858',
    borderColor: 'rgba(226, 88, 88, 0.5)',
    icon: Flag_of_Poland,
    title: 'Польська мова A2 — впевнене просування вперед!',
    courseDuration: '2 місяці',
    price: '599 zł',
    numberOfLessons: '22',
    description: (
        <div className="course-description">
            Якщо ти вже опанував основи польської (A1) і хочеш впевненіше висловлювати свої думки, розуміти мову на слух та будувати складніші речення — цей курс для тебе! Працюємо за Hurra! Po Polsku 2.<br/><br/>
            Курс підходить<br/> ✅ тим, хто завершив курс A1 або має базові знання, <br/>📚 тим, хто планує скласти іспит на карту побиту або карту поляка, <br/>🧳 тим, хто активно спілкується польською в побуті або на роботі.<br/><br/>
            Ти вивчиш<br/> 🗣️ як розповідати про свій досвід, плани, враження, <br/>📅 як вести розмову про щоденні справи, дозвілля, подорожі, роботу, <br/>📌 як орієнтуватися в складніших комунікативних ситуаціях, <br/>✍️ як писати короткі тексти: лист, оголошення, повідомлення, <br/>📖 граматику: минулий та майбутній час, відмінювання, модальні дієслова.<br/><br/>
            Після курсу ти зможеш: • вести повноцінну розмову на знайомі теми <br/> • сприймати польську мову на слух у побуті та медіа <br/> • впевнено писати прості тексти <br/> • продовжити навчання на рівні B1 або скласти сертифікатний іспит A2. Крок за кроком ми підводимо тебе до рівня, де польська стає твоєю мовою спілкування. Приєднуйся і вивчай польську з натхненням!
        </div>
    )
}

const coursePolishB1 = {

    primaryColor: '#e25858',
    borderColor: 'rgba(226, 88, 88, 0.5)',
    icon: Flag_of_Poland,
    title: 'Польська мова B1 — впевнене володіння мовою!',
    courseDuration: '2 місяці',
    price: '599 zł',
    numberOfLessons: '22',
    description: (
        <div className="course-description">
            Цей курс для тих, хто вже володіє польською на рівні A2 і хоче вийти на новий рівень — навчитися вільно висловлювати думки, дискутувати та краще розуміти носіїв мови. Програма базується на підручнику Hurra! Po Polsku 3.<br/><br/>
            Курс підходить<br/> ✅ тим, хто завершив курс A2 або має рівень нижче середнього, <br/>🎓 студентам, які планують навчання в Польщі, <br/>💼 тим, хто працює в польськомовному середовищі, <br/>📝 тим, хто готується до сертифікаційного іспиту B1.<br/><br/>
            Ти вивчиш<br/> 💬 як аргументовано висловлювати свою думку та вести дискусії, <br/>📚 як читати статті, блоги, розуміти основну ідею складніших текстів, <br/>🎙️ як розуміти розмовну мову, телевізійні програми, подкасти, <br/>✍️ як писати листи, повідомлення, опис ситуацій, <br/>📖 граматику: умовні конструкції, пасив, відносні речення.<br/><br/>
            Після курсу ти зможеш: • вільно підтримувати розмову з носіями мови <br/> • розуміти основну інформацію з новин, фільмів, інтерв&aposю <br/> • писати тексти середньої складності <br/> • бути готовим до сертифікаційного іспиту B1 або продовжити навчання на B2. Цей рівень — міст до повноцінного життя польською. Ми навчимо тебе мислити цією мовою. Записуйся та зроби ривок до впевненого володіння польською!
        </div>
    )
}

const coursePolishB2 = {

    primaryColor: '#e25858',
    borderColor: 'rgba(226, 88, 88, 0.5)',
    icon: Flag_of_Poland,
    title: 'Польська мова B2 — шлях до вільного мовлення!',
    courseDuration: '2 місяці',
    price: '599 zł',
    numberOfLessons: '22',
    description: (
        <div className="course-description">
            Ти вже володієш мовою на рівні B1 і хочеш говорити ще впевненіше, розуміти носіїв без труднощів, а також готуватися до іспитів або навчання в Польщі? Працюємо з підручником Hurra! Po Polsku 4.<br/><br/>
            Курс підходить<br/> ✅ тим, хто завершив рівень B1 або має впевнений середній рівень, <br/>🎓 студентам та абітурієнтам польських університетів, <br/>💼 професіоналам, які працюють з польськими клієнтами, <br/>📄 тим, хто готується до сертифікаційного іспиту B2.<br/><br/>
            Ти вивчиш<br/> 🗣️ як дискутувати, висловлювати думку аргументовано, <br/>📺 як розуміти фільми, репортажі, інтерв&aposю без субтитрів, <br/>📚 як читати складніші тексти: есе, публіцистика, офіційні документи, <br/>✍️ як писати есе, офіційні листи, відгуки, рецензії, <br/>📖 граматику: умовні періоди, дієприкметники, синтаксис складних речень.<br/><br/>
            Після курсу ти зможеш: • вільно підтримувати розмову з носіями на складі теми <br/> • розуміти польську мову у професійному та академічному середовищі <br/> • писати тексти високої складності з правильною структурою <br/> • здати сертифікаційний іспит B2 або навчатись у польському виші. Курс B2 відкриває перед тобою двері до справжнього двомовного життя — з польською мовою як інструментом впевненого самовираження. Приєднуйся!
        </div>
    )
}


const Page = () => {
    return (
        <div className='courses-page'>
            <div className="courses--title">
            </div>

            <section id="polish-a1" className="course-section">
                <CourseItemBig
                    primaryColor={coursePolishA1.primaryColor}
                    borderColor={coursePolishA1.borderColor}
                    icon={coursePolishA1.icon}
                    title={coursePolishA1.title}
                    description={coursePolishA1.description}
                    courseDuration={coursePolishA1.courseDuration}
                    price={coursePolishA1.price}
                    numberOfLessons={coursePolishA1.numberOfLessons}
                />
            </section>

            <div style={{height: '48px'}}></div>

            <section id="polish-a2" className="course-section">
                <CourseItemBig
                    primaryColor={coursePolishA2.primaryColor}
                    borderColor={coursePolishA2.borderColor}
                    icon={coursePolishA2.icon}
                    title={coursePolishA2.title}
                    description={coursePolishA2.description}
                    courseDuration={coursePolishA2.courseDuration}
                    price={coursePolishA2.price}
                    numberOfLessons={coursePolishA2.numberOfLessons}
                />
            </section>

            <div style={{height: '48px'}}></div>

            <section id="polish-b1" className="course-section">
                <CourseItemBig
                    primaryColor={coursePolishB1.primaryColor}
                    borderColor={coursePolishB1.borderColor}
                    icon={coursePolishB1.icon}
                    title={coursePolishB1.title}
                    description={coursePolishB1.description}
                    courseDuration={coursePolishB1.courseDuration}
                    price={coursePolishB1.price}
                    numberOfLessons={coursePolishB1.numberOfLessons}
                />
            </section>

            <div style={{height: '48px'}}></div>

            <section id="polish-b2" className="course-section">
                <CourseItemBig
                    primaryColor={coursePolishB2.primaryColor}
                    borderColor={coursePolishB2.borderColor}
                    icon={coursePolishB2.icon}
                    title={coursePolishB2.title}
                    description={coursePolishB2.description}
                    courseDuration={coursePolishB2.courseDuration}
                    price={coursePolishB2.price}
                    numberOfLessons={coursePolishB2.numberOfLessons}
                />
            </section>

            <div className="courses--title">
            </div>
        </div>
    );
};

export default Page;